import { render } from "./AboutPage.vue?vue&type=template&id=6b6e2f16"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=6b6e2f16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__